import React, { useEffect, useState } from 'react';

interface ICounterProps {
  seconds: number;
  onCountDownFinished: () => void;
  showCountDown: boolean;
}

export const CountDown = (props: ICounterProps) => {
  const [seconds, setSeconds] = useState<number>();
  useEffect(() => {
    if (seconds !== undefined && props.showCountDown) {
      if (seconds > 0) {
        setTimeout(() => setSeconds(seconds - 1), 1000);
      } else {
        props.onCountDownFinished();
      }
    } // eslint-disable-next-line
  }, [seconds]);

  useEffect(() => {
    if (props.showCountDown) {
      setSeconds(props.seconds);
    }
  }, [props.seconds, props.showCountDown]);

  return (
    <div className='small justify-content-center count-down'>
      {props.showCountDown && seconds! > 0 ? (
        <span
          className={`text-style count-down-text ${
            seconds! <= 5 ? 'red-text' : ''
          }`}
        >
          {Math.floor(seconds! / 60)}:
          {seconds! % 60 < 10 ? '0' + (seconds! % 60) : seconds! % 60}
        </span>
      ) : (
        ''
      )}
    </div>
  );
};
